// extracted by mini-css-extract-plugin
export default {"pill":"pill_pill__xJlGP","text":"pill_text__W9XC-"};